'use client';

import { useEffect, useState } from 'react';
import {
  COOKIE_CONSENT_CHANGE_EVENT,
  CookieConsent,
  getCookieConsent,
} from '@/utility/consent/cookieConsent';

/** `ready` stays false until mounted, so server and first client render match. */
export const useCookieConsent = () => {
  const [consent, setConsent] = useState<CookieConsent | null>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setConsent(getCookieConsent());
    setReady(true);

    const handleChange = (event: Event) => {
      setConsent((event as CustomEvent<CookieConsent>).detail);
    };

    window.addEventListener(COOKIE_CONSENT_CHANGE_EVENT, handleChange);
    return () =>
      window.removeEventListener(COOKIE_CONSENT_CHANGE_EVENT, handleChange);
  }, []);

  return { consent, ready };
};
